module.exports = __webpack_public_path__ + "tiktok.8b1bcc785618d309ab1bce31becb572e.svg";